import { Modal, ModalProps } from '@/components/Elements/Modal/Modal';

export const PaymentsModal = ({
  isOpen,
  onAfterOpen,
  onRequestClose,
  shouldCloseOnOverlayClick = true,
  style,
  children,
  closeButton = true,
}: ModalProps) => {
  return (
    <div className="m-auto overflow block">
      <Modal
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={onRequestClose}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        style={style}
        closeButton={closeButton}
        appElement={document.getElementById('root') || undefined}
      >
        {children}
      </Modal>
    </div>
  );
};
